module.exports = __webpack_public_path__ + "img/ring_r_i_1_1.3417eb1a.png";